<template>
  <http-put-button
    v-bind="$props"
    v-on="$listeners"
    :href="`/api/metadata/cloudaccounts/${(value || {}).id}/${type}`"
    version="v2"
    :value="(value || {})[type || '']"
    @http4xx="onError"
  >
  </http-put-button>
</template>

<i18n>
{
    "en": {
        "putCredentialButton.errorMessage": "There was an error encountered while updating the credentials of this cloud connection. If everything looks right please contact support so we can help you :)"
    }
}
</i18n>

<script>
import { toastError } from "@/components/Common/Toast.vue";
import HttpPutButton from "@/components/Common/HttpPutButton.vue";

export default {
  props: {
    ...HttpPutButton.props,
  },
  methods: {
    onError() {
      toastError(this.$t("putCredentialButton.errorMessage"));
    },
  },
};
</script>